import { Badge, type BadgeProps } from '@mui/material';
import styled from '@emotion/styled';

type ButtonUnreadCoachCommentsBadgeProps = BadgeProps & {
  unreadCoachCommentsCount: number;
};

const StyledBadge = styled(Badge)<BadgeProps>(({ theme, badgeContent }) => ({
  '.MuiBadge-badge': {
    transition: theme.transitions.create('all'),
    transform: 'translate(40%, -30%)',
    opacity: badgeContent === 0 ? 0 : 1,
  },
}));

const ButtonUnreadCoachCommentsBadge = ({
  unreadCoachCommentsCount,
  ...props
}: ButtonUnreadCoachCommentsBadgeProps) => (
  <StyledBadge
    badgeContent={unreadCoachCommentsCount}
    variant="standard"
    color="primary"
    {...props}
  />
);

export default ButtonUnreadCoachCommentsBadge;
